import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { LoadingState, ValidationError } from '../../../../types/commonTypes'
import invoiceSendReminderListApi from '../../../../middleware/api/Invoicing/Invoices/InvoicesSendReminder/invoicesSendReminderListApi'
import {
  InvoiceSendReminderDetailsListState,
  SendReminderData,
  SendReminderDataProps,
} from '../../../../types/Invoicing/Invoices/InvoiceSendReminder/invoicesSendRemindertype'
import { ApiLoadingState } from '../../../../middleware/api/apiList'
import { RootState } from '../../../../stateStore'

const invoiceSendReminderDetails = createAsyncThunk(
  'sendReminderDetailsList/invoicesendreminderDetails',
  async (_, thunkApi) => {
    try {
      return await invoiceSendReminderListApi.getSendReminderDetails()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const invoiceSendReminderBtnDetails = createAsyncThunk(
  'sendReminderDetailsList/invoiceSendReminderBtnDetails',
  async (invoiceId: number, thunkApi) => {
    try {
      return await invoiceSendReminderListApi.getSendReminderLogs(invoiceId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const invoiceReminderLogDetails = createAsyncThunk(
  'sendReminderDetailsList/invoiceReminderLogDetails',
  async (sendReminderDataProps: SendReminderDataProps, thunkApi) => {
    try {
      return await invoiceSendReminderListApi.getInvoiceReminderlog(
        sendReminderDataProps,
      )
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const initialInvoiceSendReminderState: InvoiceSendReminderDetailsListState = {
  sendReminderType: '',
  sendReminderData: [],
  isLoading: ApiLoadingState.idle,
}

const invoiceSendReminderDetailsSlice = createSlice({
  name: 'invoicesSendReminder',
  initialState: initialInvoiceSendReminderState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(invoiceSendReminderDetails.fulfilled, (state, action) => {
      state.sendReminderType = action.payload
      state.isLoading = ApiLoadingState.succeeded
    })
    builder.addCase(
      invoiceSendReminderBtnDetails.fulfilled,
      (state, action) => {
        state.sendReminderData = action.payload
        state.isLoading = ApiLoadingState.succeeded
      },
    )
    builder
      .addCase(invoiceSendReminderDetails.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addMatcher(
        isAnyOf(
          invoiceSendReminderBtnDetails.fulfilled,
          invoiceReminderLogDetails.fulfilled,
        ),
        (state) => {
          state.isLoading = ApiLoadingState.succeeded
        },
      )
      .addMatcher(
        isAnyOf(
          invoiceSendReminderBtnDetails.pending,
          invoiceReminderLogDetails.pending,
        ),
        (state) => {
          state.isLoading = ApiLoadingState.loading
        },
      )
  },
})

const isLoading = (state: RootState): LoadingState =>
  state.invoiceSendReminder.isLoading

const invoicesendReminder = (state: RootState): string =>
  state.invoiceSendReminder.sendReminderType

const invoiceSendreminderDetails = (state: RootState): SendReminderData[] =>
  state.invoiceSendReminder.sendReminderData

const invoiceSendReminderThunk = {
  invoiceSendReminderDetails,
  invoiceSendReminderBtnDetails,
  invoiceReminderLogDetails,
}
const invoiceSendReminderSelectors = {
  isLoading,
  invoicesendReminder,
  invoiceSendreminderDetails,
}
export const invoiceSendReminderService = {
  ...invoiceSendReminderThunk,
  actions: invoiceSendReminderDetailsSlice.actions,
  selectors: invoiceSendReminderSelectors,
}
const invoiceSendReminderReducer = invoiceSendReminderDetailsSlice.reducer
export default invoiceSendReminderReducer
